import React from "react"
import { ReactFC } from "types"
import { Post } from "posts/posts.types"
import { PostContextProvider, PostWrapper } from "lib-core"
import { usePostWrapperHook } from "./usePostWrapperHook"




export const ResponseWrapper: ReactFC<{ className: string, response: Post }> = ({ children, className, response }) => {
  return (
    <PostWrapper className={className} post={response} usePostWrapperHook={usePostWrapperHook}>
      <PostContextProvider post={response}>
        {children}
      </PostContextProvider>
    </PostWrapper>
  )
}

